// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_subscription from "./web_subscription.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function view(source, send) {
  const partial_arg = "Subscription account";
  const partial_arg$1 = "muted";
  const partial_arg$2 = Signal.map((function (m) {
    return m.subscriptions;
  }), source);
  const partial_arg$3 = "After confirmed quota exhaustion, Mapre tries your other accounts, then authorized team accounts of the same service.";
  const partial_arg$4 = "muted";
  const partial_arg$5 = Signal.map((function (m) {
    return m.subscription_cursor !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___003_) {
      const partial_arg = (function (param) {
        return Lui_elements.press(send, /* Refresh_subscriptions */ 0, param);
      });
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (m) {
        return m.subscriptions_loading;
      }), source)));
      const partial_arg$2 = "ghost";
      const partial_arg$3 = "Refresh subscriptions";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___004_) {
          const partial_arg = (function (param) {
            return Lui_elements.press(send, /* More_subscriptions */ 1, param);
          });
          const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
            return m.subscriptions_loading;
          }), source)));
          const partial_arg$2 = "ghost";
          const partial_arg$3 = "More subscriptions";
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = "wrap";
  const partial_arg$8 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.keyed(partial_arg$2, (function (s) {
        return s.id;
      }), Stdlib__String.compare, (function (param) {
        const s = Signal.sample(param);
        return function (param$1, param$2) {
          return Lui_elements.scoped((function (__lui_context___001_) {
            const partial_arg = (function ($$event) {
              Lui_elements.press(send, {
                TAG: /* Choose_subscription */ 6,
                _0: Signal.sample(param)
              }, $$event);
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
              if (m.subscriptions_loading || !Stdlib__List.exists((function (current) {
                  return current.id === s.id ? Mapre_web__Web_subscription.selectable(current) : false;
                }), m.subscriptions)) {
                return true;
              } else {
                return Stdlib__Option.fold(true, (function (f) {
                  return f.pending;
                }), m.form);
              }
            }), source)));
            const partial_arg$2 = "outline";
            const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(Mapre_web__Web_subscription.label, param)));
            const partial_arg$4 = {
              hd: [
                "data-subscription-id",
                s.id
              ],
              tl: /* [] */ 0
            };
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param$1, param$2);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___002_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (m) {
            const s = Stdlib__Option.bind(m.form, (function (f) {
              return f.subscription;
            }));
            if (s !== undefined) {
              return "Selected: " + Mapre_web__Web_subscription.label(s);
            } else if (m.subscriptions_loading) {
              return "Loading subscriptions...";
            } else {
              return "Connect and verify a subscription before starting a session.";
            }
          }), source)));
          const partial_arg$1 = "muted";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$9 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$10 = 0;
  const partial_arg$11 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
